import { render, staticRenderFns } from "./consultantDetails.vue?vue&type=template&id=0f940baf&scoped=true&"
import script from "./consultantDetails.vue?vue&type=script&lang=js&"
export * from "./consultantDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f940baf",
  null
  
)

export default component.exports